// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1851787754
// </auto-generated>
import {
  EmailAddress,
  Required,
  StringLength,
} from 'carehub-shared/validators';
import { Affiliation } from '../../models/provider/affiliation';
import { Certification } from '../../models/provider/certification';
import { Document } from '../../models/provider/document';
import { Education } from '../../models/provider/education';
import { License } from '../../models/provider/license';

export class Provider {
  @Required()
  providerId: string;
  contractTypeId: number;
  metroAreaId: number;
  statusId: number;
  @StringLength(255)
  caqhId: string;
  @StringLength(3000)
  ccNotes: string;
  @StringLength(50)
  degree: string;
  @StringLength(255)
  @EmailAddress()
  email: string;
  @StringLength(255)
  fax: string;
  @StringLength(256)
  firstName: string;
  @StringLength(6)
  gender: string;
  @StringLength(256)
  lastName: string;
  @StringLength(256)
  loadFileName: string;
  @StringLength(10)
  middleName: string;
  @StringLength(3000)
  notes: string;
  @StringLength(10)
  npi: string;
  @StringLength(50)
  phone: string;
  photoName: string;
  @StringLength(3000)
  photoUrl: string;
  @StringLength(255)
  providerBio: string;
  @StringLength(256)
  providerDescription: string;
  @StringLength(3000)
  providerSummary: string;
  @StringLength(256)
  updateFileName: string;
  @StringLength(255)
  url: string;
  @StringLength(255)
  w9: string;
  credentialedDate: Date | string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  specialtyId: number;
  ageGroupId: number;
  certifications: Certification[];
  educations: Education[];
  affiliations: Affiliation[];
  licenses: License[];
  documents: Document[];
}

export function initializeNewProvider(): Provider {
  const instance = new Provider();
  instance.providerId = '00000000-0000-0000-0000-000000000000';
  instance.contractTypeId = null;
  instance.metroAreaId = null;
  instance.statusId = null;
  instance.caqhId = '00000000-0000-0000-0000-000000000000';
  instance.ccNotes = '';
  instance.degree = '';
  instance.email = '';
  instance.fax = '';
  instance.firstName = '';
  instance.gender = '';
  instance.lastName = '';
  instance.loadFileName = '';
  instance.middleName = '';
  instance.notes = '';
  instance.npi = '';
  instance.phone = '';
  instance.photoName = '';
  instance.photoUrl = '';
  instance.providerBio = '';
  instance.providerDescription = '';
  instance.providerSummary = '';
  instance.updateFileName = '';
  instance.url = '';
  instance.w9 = '';
  instance.credentialedDate = null;
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.specialtyId = null;
  instance.ageGroupId = null;
  instance.certifications = null;
  instance.educations = null;
  instance.affiliations = null;
  instance.licenses = null;
  instance.documents = null;
  return instance;
}
